/**
 * Core Module - Core Services and Providers
 * Singleton module imported once in AppModule
 * Contains:
 * - HTTP Interceptors
 * - Guards
 * - Facades
 * - API Services
 */

import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Interceptors (class-based)
// Note: AuthInterceptor has been moved to backup - now using keycloak.interceptor (functional)
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { LanguageInterceptor } from './interceptors/language.interceptor';

// Guards
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';
import { KeycloakGuard } from './guards/keycloack.guard';
import { KeycloakAuthService } from './services/auth/keycloak.service';

// Facades (automatically provided in 'root')
// API Services (automatically provided in 'root')

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    // HTTP Interceptors (order matters!)
    // Note: Functional interceptors (keycloakInterceptor)
    // are configured in app.config.ts via provideHttpClient(withInterceptors([...]))
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    // Guards
    AuthGuard,
    GuestGuard,
    KeycloakAuthService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
    }
  }
}
